import axios from "axios";
import { toast } from "react-toastify";

export const axiosInstance = axios.create({
  baseURL: "https://nextphoto.pythonanywhere.com/",
});

const token = localStorage.getItem("Token")

axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`
axiosInstance.interceptors.request.use(
  async (config) => {
    //   const token = # Your token goes over here;
    if (token) {
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response !== undefined) {
      const Data = error.response.data;
      if (Data.errors) {
        toast.error(Data.error)
      } else {
        toast.error(Data.message)
        if (Data.message === "Unauthorized") {
          window.location.assign('/login');
        }
      }
    } else {
      toast.error(error.message)
    }
  });